import { render, staticRenderFns } from "./SixLayout.vue?vue&type=template&id=2f230414&scoped=true&"
import script from "./SixLayout.vue?vue&type=script&lang=js&"
export * from "./SixLayout.vue?vue&type=script&lang=js&"
import style0 from "./SixLayout.vue?vue&type=style&index=0&id=2f230414&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f230414",
  null
  
)

export default component.exports